import { render, staticRenderFns } from "./AdminUserRolesPermissions.vue?vue&type=template&id=fcac99d2&scoped=true"
import script from "./AdminUserRolesPermissions.vue?vue&type=script&lang=js"
export * from "./AdminUserRolesPermissions.vue?vue&type=script&lang=js"
import style0 from "./AdminUserRolesPermissions.vue?vue&type=style&index=0&id=fcac99d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcac99d2",
  null
  
)

export default component.exports